// extracted by mini-css-extract-plugin
export default {"selectCategoryContainer":"contactUs_selectCategoryContainer__EU2-U","selectCategoryIcon":"contactUs_selectCategoryIcon__80HIh"};